// Gera o selo "Greatest Little Table" como SVG (1080x1080) e exporta PNG.
// Usado pelo restaurante vencedor para postar no Instagram/TikTok (loop viral).

function esc(s: string): string {
  return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

export interface SealInput {
  name: string;
  subtitle: string;
  qrDataUrl: string;
}

export function buildSealSvg({ name, subtitle, qrDataUrl }: SealInput): string {
  const safeName = esc(name.slice(0, 28));
  const safeSub = esc(subtitle.slice(0, 48));
  return `<svg xmlns="http://www.w3.org/2000/svg" width="1080" height="1080" viewBox="0 0 1080 1080">
  <rect width="1080" height="1080" fill="#FBF7F0"/>
  <rect x="40" y="40" width="1000" height="1000" rx="32" fill="none" stroke="#C5532F" stroke-width="6"/>
  <rect x="64" y="64" width="952" height="952" rx="24" fill="none" stroke="#E0A23B" stroke-width="2"/>
  <text x="540" y="170" text-anchor="middle" font-family="Georgia, 'Times New Roman', serif" font-size="34" letter-spacing="6" fill="#4E6151">THE GREATEST LITTLE TABLE</text>
  <g transform="translate(540 320)">
    <path d="M0 -96 L27 -30 L98 -30 L41 12 L62 80 L0 38 L-62 80 L-41 12 L-98 -30 L-27 -30 Z" fill="#E0A23B"/>
  </g>
  <text x="540" y="500" text-anchor="middle" font-family="Georgia, 'Times New Roman', serif" font-size="76" font-weight="bold" fill="#2B2723">${safeName}</text>
  <text x="540" y="560" text-anchor="middle" font-family="system-ui, sans-serif" font-size="30" fill="#8A7E6F">${safeSub}</text>
  <rect x="380" y="630" width="320" height="320" rx="16" fill="#FFFFFF" stroke="#E6DCC9" stroke-width="2"/>
  <image x="400" y="650" width="280" height="280" href="${qrDataUrl}"/>
  <text x="540" y="1000" text-anchor="middle" font-family="Georgia, serif" font-size="30" fill="#C5532F">La petite table</text>
</svg>`;
}

export function downloadSealPng(svg: string, filename: string, size = 1080): void {
  const blob = new Blob([svg], { type: 'image/svg+xml;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement('canvas');
    canvas.width = size;
    canvas.height = size;
    const ctx = canvas.getContext('2d');
    if (!ctx) return;
    ctx.drawImage(img, 0, 0, size, size);
    URL.revokeObjectURL(url);
    canvas.toBlob((b) => {
      if (!b) return;
      const a = document.createElement('a');
      a.href = URL.createObjectURL(b);
      a.download = filename;
      a.click();
    }, 'image/png');
  };
  img.src = url;
}
